import { render, staticRenderFns } from "./MenuNewCopy.vue?vue&type=template&id=2c21b13b&scoped=true&"
import script from "./MenuNewCopy.vue?vue&type=script&lang=js&"
export * from "./MenuNewCopy.vue?vue&type=script&lang=js&"
import style0 from "./MenuNewCopy.vue?vue&type=style&index=0&id=2c21b13b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c21b13b",
  null
  
)

export default component.exports